import { ModalRef } from '@components/ui/modal';

export const displayDiscardConfirmModal = (
  modal: ModalRef,
  primaryAction: () => void,
  secondaryAction?: () => void,
) => {
  modal.display(
    () => (
      <p>
        If you discard changes, you’ll delete any edits you made since you last
        saved.
      </p>
    ),
    {
      primaryAction: {
        content: 'Confirm',
        destructive: true,
        onAction: primaryAction,
      },
      secondaryAction: {
        content: 'Cancel',
        onAction: secondaryAction,
      },
      title: 'Unsaved changes',
    },
  );
};
